/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');
var GetUsersForRole = require('common/services/GetUsersForRole');

var GetInvestigationInquiry = require('../services/GetInvestigationInquiry');
var GetInvInqIdentifiers = require('../services/GetInvInqIdentifiers');
var SecInvInqNextStepEditView = require('../views/SecInvInqNextStepEditView');

module.exports = function(invInqId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetInvestigationInquiry(invInqId), GetInvInqIdentifiers(invInqId), GetUsersForRole('SC - User'))
    .done(function(invInq, identifiers, users) {
      NavUtils.navigate('#sec/investigation-inquiry/' + invInqId + '/edit-next-steps');
      Scaffold.content.show(
        new SecInvInqNextStepEditView({
          model: new Backbone.Model({
            identifiers: identifiers,
            invInqId: invInqId,
            invInq: invInq,
            users: users
          })
        })
      );
      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
